import {notNull} from "./assert.js";

async function executeScript(script: HTMLScriptElement) {
        // Create a copy of the script and swap it out so the browser executes it
        const newScript = document.createElement('script');
        [...script.attributes].map(attr => newScript.setAttribute(attr.name, attr.value));
        newScript.textContent = script.textContent;

        const parentNode = notNull(script.parentNode);
        parentNode.replaceChild(newScript, script);
    }

export default async (element: HTMLElement) => {
    [...element.querySelectorAll<HTMLScriptElement>('script')].map(script => executeScript(script));
}
